import { Injectable } from '@angular/core';
import { Apollo } from 'apollo-angular';
import { ApolloQueryResult } from 'apollo-client';
import { Observable } from 'rxjs';
import { FetchResult } from 'apollo-link';
import { GetUserInput } from '../../../shared/data/inputs/get-user.input';
import { SocialUserQueryResponse } from '../../../shared/data/responses/social-user-query.response';
import { GetUserQuery } from '../../../shared/data/gql/query/get-user.query';
import { ProfileUpdateInput } from '../../../shared/data/inputs/profile-update.input';
import { UpdateUserMutationResponse } from '../../../shared/data/responses/update-user-mutation.response';
import { updateUserMutation } from '../../../shared/data/gql/mutation/update-user-mutation';
import { SuggestedInput } from '../../../shared/data/inputs/suggested.input';
import { SuggestUsersResponse } from '../../../shared/data/responses/suggest-users.response';
import { getSuggestedUsersQuery } from '../../../shared/data/gql/query/get-suggested-users.query';
import { getPeopleToFollowQuery } from '../../../shared/data/gql/query/get-people-to-follow.query';
import { PeopleToFollowResponse } from '../../../shared/data/responses/people-to-follow.response';
import { getTrendingNowQuery } from '../../../shared/data/gql/query/get-trending-now.query';
import { TrendingNowResponse } from '../../../shared/data/responses/trending-now.response';
import { getSuggestHashtagQuery } from '../../../shared/data/gql/query/get-suggest-hashtag.query';
import { SuggestHashtagResponse } from '../../../shared/data/responses/suggest-hashtag.response';
import { PeopleToFollowInput } from '../../../shared/data/inputs/people-to-follow.input';

@Injectable({
  providedIn: 'root'
})
export class SocialUserService {
  constructor(private apollo: Apollo) {}

  getUser(
    input: GetUserInput
  ): Observable<ApolloQueryResult<SocialUserQueryResponse>> {
    return this.apollo.query<SocialUserQueryResponse>({
      query: GetUserQuery,
      variables: input
    });
  }

  updateProfileData(
    input: ProfileUpdateInput
  ): Observable<FetchResult<UpdateUserMutationResponse>> {
    return this.apollo.mutate<UpdateUserMutationResponse>({
      mutation: updateUserMutation,
      variables: {
        profile: input
      }
    });
  }

  getSuggestedUsers(
    input: SuggestedInput
  ): Observable<ApolloQueryResult<SuggestUsersResponse>> {
    return this.apollo.query<SuggestUsersResponse>({
      query: getSuggestedUsersQuery,
      variables: input
    });
  }

  getPeopleToFollow(
    input?: PeopleToFollowInput
  ): Observable<ApolloQueryResult<PeopleToFollowResponse>> {
    return this.apollo.query<PeopleToFollowResponse>({
      query: getPeopleToFollowQuery,
      variables: input
    });
  }

  getTrendingNow(
    count?: number
  ): Observable<ApolloQueryResult<TrendingNowResponse>> {
    return this.apollo.query<TrendingNowResponse>({
      query: getTrendingNowQuery,
      variables: { count }
    });
  }

  getSuggestedHHashtags(
    input: SuggestedInput
  ): Observable<ApolloQueryResult<SuggestHashtagResponse>> {
    return this.apollo.query<SuggestHashtagResponse>({
      query: getSuggestHashtagQuery,
      variables: input
    });
  }
}
